import { Box, Typography } from '@mui/material';

import palette from 'src/theme/palette';

interface ProductThumbProps {
  imageUrl?: string | null;
  title: string;
  size?: number;
  radius?: number;
}

export function ProductThumb({
  imageUrl,
  title,
  size = 40,
  radius = 12,
}: ProductThumbProps) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        minWidth: size,
        borderRadius: `${radius}px`,
        overflow: 'hidden',
        bgcolor: '#f8fafc',
        border: '1px solid rgba(15, 23, 42, 0.06)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {imageUrl ? (
        <Box
          component="img"
          src={imageUrl}
          alt={title}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            // Modelli / verticali: ancoraggio in alto evita che il crop “centrale” tagli la testa
            objectPosition: 'center top',
            display: 'block',
            boxSizing: 'border-box',
          }}
        />
      ) : (
        <Typography
          variant="caption"
          sx={{
            color: palette.text.secondary,
            fontWeight: 700,
            textTransform: 'uppercase',
          }}
        >
          {title.slice(0, 1)}
        </Typography>
      )}
    </Box>
  );
}

export default ProductThumb;
